import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';

export const DropdownMenuRoot = DropdownMenuPrimitive.Root;
DropdownMenuRoot.displayName = DropdownMenuPrimitive.Root.displayName;
